import axios from "axios";

//Exporting actions
export default {
	//actions login
	login({ commit }, user) {
		//commit("");
		return new Promise((resolve, reject) => {
			//showing button loading process
			commit("auth_request");
			axios({
				url:
					process.env.VUE_APP_ENDPOINT +
					process.env.VUE_APP_VERSION +
					"/user/login",
				data: user,
				method: "POST",
			})
				.then((resp) => {
					const token = resp.data.data.refreshToken;
					//save token
					localStorage.setItem("token", +"Bearer " + token);
					axios.defaults.headers.common["Authorization"] = token;
					this.state.token = token;
					this.state.status = "success";
					resolve(resp);
				})
				.catch((err) => {
					//commit("auth_error_login");
					commit("logout");
					localStorage.removeItem("token");
					reject(err);
				});
		});
	},
	//actions register
	register({ commit }, user) {
		return new Promise((resolve, reject) => {
			//showing button loading process
			commit("auth_request");
			axios({
				url:
					process.env.VUE_APP_ENDPOINT +
					process.env.VUE_APP_VERSION +
					"/user/register",
				data: user,
				method: "POST",
			})
				.then((resp) => {
					const token = resp.data.data.refreshToken;
					//save token
					localStorage.setItem("token", +"Bearer " + token);
					axios.defaults.headers.common["Authorization"] = token;
					this.state.token = token;
					this.state.status = "success";
					resolve(resp);
				})
				.catch((err) => {
					commit("logout");
					localStorage.removeItem("token");
					reject(err);
				});
		});
	},
	//action logout
	logout({ commit }) {
		return new Promise((resolve, reject) => {
			commit("logout");
			localStorage.removeItem("token");
			delete axios.defaults.headers.common["Authorization"];
			resolve();
			reject();
		});
	},
};
